import { SubscriptionRequest } from "@somewear/api";
import { Api, AuthController, selectActiveUserAccountId } from "@somewear/auth";
import { Sentry } from "@somewear/model";
import { apiSubscriptionsSuccess } from "@somewear/subscription";
import { refreshInitialAppData } from "@web/app/appSlice";
import Loader from "@web/common/Loader";
import Paths from "@web/common/Paths";
import * as React from "react";
import { useEffect, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import type { RouteComponentProps } from "react-router";
import { Redirect, withRouter } from "react-router";

import SubscriptionView from "./SubscriptionView";

const SubscriptionSelection: React.FunctionComponent<RouteComponentProps> = (props) => {
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const user = AuthController.service.getCurrentAuthUser();
	const activeUserAccountId = useSelector(selectActiveUserAccountId);

	useEffect(() => {
		// if we make it to this step and do not have an active account we need to initialize our data
		if (activeUserAccountId === undefined) {
			batch(() => {
				// setLoading(true);
				dispatch(refreshInitialAppData());
			});
		}
	}, [dispatch, activeUserAccountId, setLoading]);

	function setup(owner: boolean) {
		setLoading(true);
		const subscription = new SubscriptionRequest();
		subscription.setPlan(SubscriptionRequest.Plan.NONE);

		Api.registerSubscription(subscription).subscribe(
			(subscription) => {
				dispatch(apiSubscriptionsSuccess([subscription.toObject()]));
				if (owner) {
					props.history.push(Paths.Setup);
				}
			},
			(error) => {
				alert("There was an error while creating your account");
				Sentry.captureException(error);
				AuthController.service.signOut$().subscribe();
			},
		);
	}

	if (
		!user!.phoneNumber &&
		!user!.email!.includes("someweardev") &&
		!user!.email!.includes("someweartest") &&
		!user!.email!.endsWith("@somewear.co")
	) {
		return <Redirect to={Paths.Phone} />;
	}
	if (loading) {
		return <Loader />;
	} else return <SubscriptionView setup={setup} />;
};

export default withRouter(SubscriptionSelection);
